import React, { useCallback } from "react";
import { Icon } from "../../../ui/Icon";
import { Toolbar } from "../../../ui/Toolbar";
import { Popover } from "../../../ui/Popover";
import { AlignmentOption } from "../types";
import { Surface } from "../../../ui/Surface";
import { DropdownButton } from "../../../ui/Dropdown";

export const AlignmentPicker = ({ alignmentOptions }: { alignmentOptions?: AlignmentOption[] }) => {
    const renderAlignmentOptions = useCallback(
        ({ onClose }) => {
            return alignmentOptions?.map((option, i) => {
                return (
                    <DropdownButton
                        key={option.id + i}
                        onClick={() => {
                            option.onClick();
                            onClose();
                        }}
                        isActive={option.isActive()}>
                        <Icon name={option.icon} style={{ width: "16px", height: "16px", marginRight: "4px" }} />
                        {option.tooltip}
                    </DropdownButton>
                );
            });
        },
        [alignmentOptions]
    );

    if (!alignmentOptions) {
        return null;
    }

    return (
        <Popover
            PopupProps={{ placement: "top" }}
            content={({ closePopup }) => (
                <Surface style={{ display: "flex", flexDirection: "column", gap: "4px", padding: "16px 8px" }}>
                    {renderAlignmentOptions({ onClose: closePopup })}
                </Surface>
            )}>
            {({ openPopup }) => {
                const activeAlignment = alignmentOptions.find(option => option.isActive()) as AlignmentOption;

                return (
                    <Toolbar.Button tooltip="Alignments" onClick={openPopup}>
                        <Icon name={activeAlignment?.icon || "AlignLeft"} />
                        <Icon name="ChevronDown" style={{ width: "8px", height: "8px" }} />
                    </Toolbar.Button>
                );
            }}
        </Popover>
    );
};
